import { Fragment, forwardRef } from "react";
import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { Switch } from "@headlessui/react";
import { useState } from "react";
/*
  This example requires some changes to your config:
  
  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ],
  }
  ```
*/
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
const Input = forwardRef((props, ref) => {
  //const [enabled, setEnabled] = useState(props.enabled)

  let inputElement = null;

  const inputSize = () => {
    if (props.inputSize) {
      if (props.inputSize == "xs") return "px-2.5";
      if (props.inputSize == "sm") return "px-3";
      if (props.inputSize == "md") return "px-4";
      if (props.inputSize == "lg") return "px-4";
      if (props.inputSize == "xl") return "px-6";
    } else {
      return "px-4";
    }
  };

  switch (props.elementtype) {
    case "input":
      inputElement = (
        <div className="relative mt-1 rounded-md shadow-xs">
          <input className="block h-8 w-full rounded-md border-gray-300 focus:border-primary-500 focus:ring-primary-500 text-sm" {...props} ref={ref} />
        </div>
      );
      break;

    case "select":
      inputElement = (
        <div>
          <select
            className="mt-1 block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 focus:border-primary-500 focus:outline-none focus:ring-primary-500 text-sm"
            {...props}
            ref={ref}
          >
            {props.addBlankOption && <option></option>}
            
            {props.options &&
              props.options.map((option, index) => (
                <option value={option?.value} key={index} className={`${option?.cssClass}`}>
                  {option?.data}
                </option>
              ))}
          </select>
        </div>
      );
      break;

    case "checkbox":
      inputElement = (
        <>
          {props.options ? (
            <fieldset>
              <legend className="text-lg font-medium text-gray-900"></legend>
              <div className="mt-4 divide-y divide-gray-200 border-gray-200">
                {props.options.map((option) => (
                  <div key={option.value} className="relative flex items-start py-4">
                    <div className="min-w-0 flex-1 text-sm">
                      <label htmlFor={option.value} className="select-none font-medium text-gray-700">
                        {option.data}
                      </label>
                    </div>
                    <div className="ml-3 flex h-5 items-center">
                      <input id={option.value} name={option.value} type="checkbox" className="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500" />
                    </div>
                  </div>
                ))}
              </div>
            </fieldset>
          ) : (
            <div className="relative flex items-start">
              <div className="flex h-5 items-center">
                <input
                  id={props.id}
                  name={props.name}
                  aria-describedby="comments-description"
                  type="checkbox"
                  className="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500"
                />
              </div>
              <div className="ml-3 text-sm">
                <label htmlFor="comments" className="font-medium text-gray-700">
                  {props.Label}
                </label>
                {/* <p id="comments-description" className="text-gray-500">
            Get notified when someones posts a comment on a posting.
          </p> */}
              </div>
            </div>
          )}
        </>
      );
      break;

    case "imageCheckbox":
      inputElement = (
        <div>
          <input type="checkbox" id={props.id} value="" className="hidden peer" required="" />
          <label
            for={props.id}
            className="inline-flex items-center justify-between w-full p-3 text-gray-500 bg-white border-2 border-gray-200 rounded-lg cursor-pointer dark:hover:text-base dark:border-gray-700 peer-checked:border-primary-500 hover:text-gray-600 dark:peer-checked:text-gray-300 peer-checked:text-gray-600 hover:bg-gray-50 dark:text-gray-400 dark:bg-gray-800 dark:hover:bg-gray-700"
          >
            <div className="block">
              <svg className="mb-2 w-7 h-7 text-sky-500" fill="currentColor" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path d="M418.2 177.2c-5.4-1.8-10.8-3.5-16.2-5.1.9-3.7 1.7-7.4 2.5-11.1 12.3-59.6 4.2-107.5-23.1-123.3-26.3-15.1-69.2.6-112.6 38.4-4.3 3.7-8.5 7.6-12.5 11.5-2.7-2.6-5.5-5.2-8.3-7.7-45.5-40.4-91.1-57.4-118.4-41.5-26.2 15.2-34 60.3-23 116.7 1.1 5.6 2.3 11.1 3.7 16.7-6.4 1.8-12.7 3.8-18.6 5.9C38.3 196.2 0 225.4 0 255.6c0 31.2 40.8 62.5 96.3 81.5 4.5 1.5 9 3 13.6 4.3-1.5 6-2.8 11.9-4 18-10.5 55.5-2.3 99.5 23.9 114.6 27 15.6 72.4-.4 116.6-39.1 3.5-3.1 7-6.3 10.5-9.7 4.4 4.3 9 8.4 13.6 12.4 42.8 36.8 85.1 51.7 111.2 36.6 27-15.6 35.8-62.9 24.4-120.5-.9-4.4-1.9-8.9-3-13.5 3.2-.9 6.3-1.9 9.4-2.9 57.7-19.1 99.5-50 99.5-81.7 0-30.3-39.4-59.7-93.8-78.4zM282.9 92.3c37.2-32.4 71.9-45.1 87.7-36 16.9 9.7 23.4 48.9 12.8 100.4-.7 3.4-1.4 6.7-2.3 10-22.2-5-44.7-8.6-67.3-10.6-13-18.6-27.2-36.4-42.6-53.1 3.9-3.7 7.7-7.2 11.7-10.7zM167.2 307.5c5.1 8.7 10.3 17.4 15.8 25.9-15.6-1.7-31.1-4.2-46.4-7.5 4.4-14.4 9.9-29.3 16.3-44.5 4.6 8.8 9.3 17.5 14.3 26.1zm-30.3-120.3c14.4-3.2 29.7-5.8 45.6-7.8-5.3 8.3-10.5 16.8-15.4 25.4-4.9 8.5-9.7 17.2-14.2 26-6.3-14.9-11.6-29.5-16-43.6zm27.4 68.9c6.6-13.8 13.8-27.3 21.4-40.6s15.8-26.2 24.4-38.9c15-1.1 30.3-1.7 45.9-1.7s31 .6 45.9 1.7c8.5 12.6 16.6 25.5 24.3 38.7s14.9 26.7 21.7 40.4c-6.7 13.8-13.9 27.4-21.6 40.8-7.6 13.3-15.7 26.2-24.2 39-14.9 1.1-30.4 1.6-46.1 1.6s-30.9-.5-45.6-1.4c-8.7-12.7-16.9-25.7-24.6-39s-14.8-26.8-21.5-40.6zm180.6 51.2c5.1-8.8 9.9-17.7 14.6-26.7 6.4 14.5 12 29.2 16.9 44.3-15.5 3.5-31.2 6.2-47 8 5.4-8.4 10.5-17 15.5-25.6zm14.4-76.5c-4.7-8.8-9.5-17.6-14.5-26.2-4.9-8.5-10-16.9-15.3-25.2 16.1 2 31.5 4.7 45.9 8-4.6 14.8-10 29.2-16.1 43.4zM256.2 118.3c10.5 11.4 20.4 23.4 29.6 35.8-19.8-.9-39.7-.9-59.5 0 9.8-12.9 19.9-24.9 29.9-35.8zM140.2 57c16.8-9.8 54.1 4.2 93.4 39 2.5 2.2 5 4.6 7.6 7-15.5 16.7-29.8 34.5-42.9 53.1-22.6 2-45 5.5-67.2 10.4-1.3-5.1-2.4-10.3-3.5-15.5-9.4-48.4-3.2-84.9 12.6-94zm-24.5 263.6c-4.2-1.2-8.3-2.5-12.4-3.9-21.3-6.7-45.5-17.3-63-31.2-10.1-7-16.9-17.8-18.8-29.9 0-18.3 31.6-41.7 77.2-57.6 5.7-2 11.5-3.8 17.3-5.5 6.8 21.7 15 43 24.5 63.6-9.6 20.9-17.9 42.5-24.8 64.5zm116.6 98c-16.5 15.1-35.6 27.1-56.4 35.3-11.1 5.3-23.9 5.8-35.3 1.3-15.9-9.2-22.5-44.5-13.5-92 1.1-5.6 2.3-11.2 3.7-16.7 22.4 4.8 45 8.1 67.9 9.8 13.2 18.7 27.7 36.6 43.2 53.4-3.2 3.1-6.4 6.1-9.6 8.9zm24.5-24.3c-10.2-11-20.4-23.2-30.3-36.3 9.6.4 19.5.6 29.5.6 10.3 0 20.4-.2 30.4-.7-9.2 12.7-19.1 24.8-29.6 36.4zm130.7 30c-.9 12.2-6.9 23.6-16.5 31.3-15.9 9.2-49.8-2.8-86.4-34.2-4.2-3.6-8.4-7.5-12.7-11.5 15.3-16.9 29.4-34.8 42.2-53.6 22.9-1.9 45.7-5.4 68.2-10.5 1 4.1 1.9 8.2 2.7 12.2 4.9 21.6 5.7 44.1 2.5 66.3zm18.2-107.5c-2.8.9-5.6 1.8-8.5 2.6-7-21.8-15.6-43.1-25.5-63.8 9.6-20.4 17.7-41.4 24.5-62.9 5.2 1.5 10.2 3.1 15 4.7 46.6 16 79.3 39.8 79.3 58 0 19.6-34.9 44.9-84.8 61.4zm-149.7-15c25.3 0 45.8-20.5 45.8-45.8s-20.5-45.8-45.8-45.8c-25.3 0-45.8 20.5-45.8 45.8s20.5 45.8 45.8 45.8z" />
              </svg>
              {props.label ? <div className="w-full text-lg font-semibold">{props.label}</div> : ""}
            </div>
          </label>
        </div>
      );
      break;

    case "radio":
      inputElement = (
        <div>
          <fieldset className="mt-4">
            <legend className="sr-only">Notification method</legend>
            <div className="space-y-4">
              <div className="flex items-center">
                <input
                  id={props.id}
                  name={props.name}
                  type="radio"
                  // defaultChecked={notificationMethod.id === "email"}
                  className="h-4 w-4 border-gray-300 text-primary-600 focus:ring-primary-500"
                />

                <label htmlFor={props.id} className="ml-3 block text-sm font-medium text-gray-700">
                  {props.label}
                </label>
              </div>
            </div>
          </fieldset>
        </div>
      );
      break;

    case "inputDropdown":
      inputElement = (
        <div className="relative mt-1 rounded-md shadow-xs">
          <input className="block w-full rounded-md border-gray-300 pr-12 focus:border-primary-500 focus:ring-primary-500 text-sm" {...props} />
          <div className="absolute inset-y-0 right-0 flex items-center">
            {/* <label htmlFor={props.id} className="sr-only">
              Currency
            </label> */}
            <select
              id={props.id}
              name={props.name}
              value={props.optionValue}
              onChange={props.onOptionChanged}
              className="h-full rounded-md border-transparent bg-transparent py-0 pl-2 pr-7 text-gray-500 focus:border-primary-500 focus:ring-primary-500 sm:text-sm"
            >
              {props.options &&
                props.options.map((option, index) => (
                  <option key={option.value} value={option.value}>
                    {option.data}
                  </option>
                ))}
            </select>
          </div>
        </div>
      );
      break;

    case "switch":
      inputElement = (
        <Switch
          checked={props.enabled}
          className={classNames(
            props.enabled ? "bg-primary-600" : "bg-gray-200",
            "relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary-600 focus:ring-offset-2"
          )}
          {...props}
        >
          <span className="sr-only">Use setting</span>
          <span
            className={classNames(
              props.enabled ? "translate-x-5" : "translate-x-0",
              "pointer-events-none relative inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
            )}
          >
            <span
              className={classNames(
                props.enabled ? "opacity-0 duration-100 ease-out" : "opacity-100 duration-200 ease-in",
                "absolute inset-0 flex h-full w-full items-center justify-center transition-opacity"
              )}
              aria-hidden="true"
            >
              <svg className="h-3 w-3 text-gray-400" fill="none" viewBox="0 0 12 12">
                <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </span>
            <span
              className={classNames(
                props.enabled ? "opacity-100 duration-200 ease-in" : "opacity-0 duration-100 ease-out",
                "absolute inset-0 flex h-full w-full items-center justify-center transition-opacity"
              )}
              aria-hidden="true"
            >
              <svg className="h-3 w-3 text-primary-600" fill="currentColor" viewBox="0 0 12 12">
                <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
              </svg>
            </span>
          </span>
        </Switch>
      );
      break;
    case "label":
      // inputElement = (
      //   <div className="relative mt-1 rounded-md shadow-xs">
      //     <input
      //       className="disabled block w-full rounded-md border-gray-300 pl-7 pr-12 focus:border-primary-500 focus:ring-primary-500 text-sm"
      //       {...props}
      //     />
      //   </div>
      // );
      break;
    default:
      break;
  }

  return (
    <div>
      {props.elementtype !== "radio" && props.elementtype !== "checkbox" && props.elementtype !== "imageCheckbox" ? (
        <div className="flex">
          <label
            // htmlFor={props.id}
            className="block text-sm font-medium text-gray-700"
          >
            {props.label}
          </label>
          {props.elementtype == "label" && <label className="block text-sm text-gray-700">: {props.value}</label>}
        </div>
      ) : (
        ""
      )}

      {/* <div className="relative mt-1 rounded-md shadow-xs"> */}
      {inputElement}
      {/* </div> */}
    </div>
  );
});

export default Input;
